/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Countdown_DayInputs */

const en_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} d`)
};

const ar_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} يوم`)
};

const de_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} d`)
};

const es_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} d`)
};

const fr_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} j`)
};

const it_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} g`)
};

const ja_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}日`)
};

const ko_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}일`)
};

const pt_br_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} d`)
};

const ru_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} д.`)
};

const th_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ว.`)
};

const tr_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} g`)
};

const zh_cn_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} 天`)
};

const zh_tw_countdown_day = /** @type {(inputs: Countdown_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} 天`)
};

/**
* | output |
* | --- |
* | "{day} d" |
*
* @param {Countdown_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const countdown_day = /** @type {((inputs: Countdown_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Countdown_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_countdown_day(inputs)
	if (locale === "ar") return ar_countdown_day(inputs)
	if (locale === "de") return de_countdown_day(inputs)
	if (locale === "es") return es_countdown_day(inputs)
	if (locale === "fr") return fr_countdown_day(inputs)
	if (locale === "it") return it_countdown_day(inputs)
	if (locale === "ja") return ja_countdown_day(inputs)
	if (locale === "ko") return ko_countdown_day(inputs)
	if (locale === "pt_br") return pt_br_countdown_day(inputs)
	if (locale === "ru") return ru_countdown_day(inputs)
	if (locale === "th") return th_countdown_day(inputs)
	if (locale === "tr") return tr_countdown_day(inputs)
	if (locale === "zh_cn") return zh_cn_countdown_day(inputs)
	return zh_tw_countdown_day(inputs)
});